import { jsx as _jsx } from "react/jsx-runtime";
const X = ({ size, additionalClasses = [] }) => {
    return (_jsx("svg", { className: `${size} ${additionalClasses.join(" ")}`, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", strokeWidth: "2", role: "img", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M6 18L18 6M6 6l12 12" }) }));
};
export default X;
